import { useEffect } from "react";
import { Identifier } from "react-admin";
import { useForm } from "react-final-form";

interface Props {
  selectedIds: Array<Identifier>;
}

export const BulkAssignFormInit = (props: Props) => {
  const form = useForm();
  useEffect(() => {
    form.registerField("ids", () => {}, { value: true });
    form.change("ids", props.selectedIds);
  }, [form, props]);

  return null;
};
